import { render } from "./AlzataConfirmAccount.vue?vue&type=template&id=3720a87e"
import script from "./AlzataConfirmAccount.vue?vue&type=script&lang=js"
export * from "./AlzataConfirmAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__